import Layout from 'layout';
import { ExtendGridBox } from 'styles/integrations';
import SideBar from 'components/marketplace/sideBar';
import Content from 'components/marketplace/content';
import Banner from 'components/marketplace/banner';
import { frontmatter } from 'data/marketplace/integrations';
import arrow from 'img/ui/arrow_black.svg';
import OwnAppSection from 'components/marketplace/ownAppSection';

const Support = () => {
  const [mostPopularCard] = frontmatter.items.filter((item) => item.title === 'Intercom');
  return (
    <Layout
      metaTitle="Support | Integrations"
      canonical="/integrations/for-support/"
      metaDescription="See how the users interact with the app and find out what caused the error. LiveSession helps with spotting bugs in the process."
    >
      <div className="container">
        <ExtendGridBox>
          <div className="breadcrumbs">
            <p>
              <a href="/integrations/">Integrations</a>
            </p>
            <img src={arrow} alt="arrow" title="Arrow" />
            <p>
              <a href="/integrations/for-support/">
                <strong>Support</strong>
              </a>
            </p>
          </div>
          <SideBar activeCategory="Support" />
          <Content activeCategory="Support" hideTitle>
            <Banner
              activeCategory="Support"
              card={mostPopularCard}
              text="See how the users interact with the app and find out what caused the error. LiveSession helps with spotting bugs in the process."
            />
          </Content>
        </ExtendGridBox>
        <OwnAppSection />
      </div>
    </Layout>
  );
};

export default Support;
